//export const SERVICE_URL = 'http://api.everystreetchallenge.com';
export const SERVICE_URL = 'https://lttapjswjh.execute-api.eu-west-1.amazonaws.com/v';
//export const SERVICE_URL='http://localhost:8080/2015-03-31/functions/function/invocations';
export const OPEN_STREET_MAP = 'https://nominatim.openstreetmap.org/search.php';
